export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_1-f007ee547b27ed3e4836ec84838c3ad7.webp";